export const JSON_CONTENT_TYPE = "application/json; charset=utf-8";

export interface JsonInit {
  noStore?: boolean;
  headers?: HeadersInit;
}

export function json(
  status: number,
  body: unknown,
  { noStore = false, headers }: JsonInit = {},
): Response {
  const merged = new Headers(headers);
  merged.set("content-type", JSON_CONTENT_TYPE);
  if (noStore) merged.set("cache-control", "no-store");
  return new Response(JSON.stringify(body), { status, headers: merged });
}

// Counts bytes as they stream and cancels past the cap: `text.length` counts
// UTF-16 units, not bytes, and a chunked body has no Content-Length to refuse
// before `request.text()` buffers it all. Stream errors are left to callers.
export async function readBodyBounded(
  message: Pick<Request, "body">,
  maxBytes: number,
): Promise<string | null> {
  const reader = message.body?.getReader();
  if (!reader) return "";
  const chunks: Uint8Array[] = [];
  let received = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    received += value.byteLength;
    if (received > maxBytes) {
      await reader.cancel();
      return null;
    }
    chunks.push(value);
  }
  const merged = new Uint8Array(received);
  let offset = 0;
  for (const chunk of chunks) {
    merged.set(chunk, offset);
    offset += chunk.byteLength;
  }
  return new TextDecoder().decode(merged);
}
